import * as Styles from './styles'

const TabLabel = ({ label, hasError }) => (
  <Styles.Container $hasError={hasError}>
    {hasError && <Styles.ErrorIndicator data-testid="tab-error-indicator" />}
    {label}
  </Styles.Container>
)

export default TabLabel
